import React, { Component } from "react";
import MarkingForm from "../MarkingForm/MarkingForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MarkingPage
Description : Componente que invoca al componente MarkingForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class MarkingPage extends Component {
    render() {
        return (
            <MarkingForm />
        )
    }
}

export default MarkingPage;